import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

interface PageHeroProps {
  title: string;
  subtitle?: string;
}

const PageHero: React.FC<PageHeroProps> = ({ title, subtitle }) => {
  const { language } = useLanguage();

  return (
    <div className="relative overflow-hidden bg-gradient-to-br from-indigo-700 via-purple-600 to-purple-500">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-72 h-72 bg-white rounded-full mix-blend-multiply opacity-10 -translate-x-1/4 -translate-y-1/4"></div>
      <div className="absolute top-0 right-0 w-72 h-72 bg-white rounded-full mix-blend-multiply opacity-10 translate-x-1/4 -translate-y-1/4"></div>
      <div className="absolute bottom-0 left-1/2 w-72 h-72 bg-white rounded-full mix-blend-multiply opacity-10 -translate-x-1/2 translate-y-1/4"></div>
      
      {/* Subtle animated shapes */}
      <div className="absolute inset-0 overflow-hidden opacity-20">
        <div className="absolute -top-10 -left-10 w-40 h-40 bg-white rounded-lg rotate-12 animate-float"></div>
        <div className="absolute top-20 right-10 w-20 h-20 bg-white rounded-full animate-float-delay"></div>
        <div className="absolute bottom-10 left-1/3 w-32 h-32 bg-white rounded-lg -rotate-12 animate-float-slow"></div>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20 lg:py-24 relative z-10">
        <div className="text-center">
          <h1 className="text-4xl font-extrabold text-white tracking-tight sm:text-5xl lg:text-6xl">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-6 max-w-xl mx-auto text-xl text-indigo-100">
              {subtitle}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default PageHero; 